/**
 * Constants for AI Image and Video Generation
 */

// Quality presets with defined settings
export const QUALITY_PRESETS = [
  { 
    name: 'Standard', 
    value: 'standard',
    use_refiner: false,
    steps: 40,
    refiner_steps: 20,
    guidance_scale: 7.5,
    description: 'Good quality • ~80 seconds'
  },
  { 
    name: 'High Quality', 
    value: 'high',
    use_refiner: true,
    steps: 60,
    refiner_steps: 20,
    guidance_scale: 8.0,
    description: 'Great quality • ~150 seconds'
  },
  { 
    name: 'Professional', 
    value: 'professional',
    use_refiner: true,
    steps: 80,
    refiner_steps: 20,
    guidance_scale: 8.5,
    description: 'Maximum quality • ~240 seconds'
  }
];

// Style presets
export const STYLE_PRESETS = [
  { name: 'Pixar 3D', value: 'pixar 3d, animated, colorful, cartoon style, high quality render' },
  { name: 'Photorealistic', value: 'realistic, photographic, high resolution, detailed, professional photography' },
  { name: 'Oil Painting', value: 'oil painting, artistic, classical art style, brushstrokes, fine art' },
  { name: 'Digital Art', value: 'digital art, concept art, detailed, vibrant colors, professional illustration' },
  { name: 'Watercolor', value: 'watercolor painting, soft colors, artistic, hand-painted style' }
];

// Aspect ratios
export const ASPECT_RATIOS = [
  { name: '16:9', width: 1536, height: 864 },
  { name: '9:16', width: 864, height: 1536 },
  { name: '1:1', width: 1024, height: 1024 }
];

// Video quality options
export const VIDEO_QUALITIES = [
  { name: 'Standard', value: 'standard' },
  { name: 'High', value: 'high' },
  { name: 'Ultra', value: 'ultra' }
];

// Video duration options
export const VIDEO_DURATIONS = [
  { name: '3 seconds', value: 3 },
  { name: '5 seconds', value: 5 },
  { name: '10 seconds', value: 10 },
  { name: '15 seconds', value: 15 }
];

// Style mapping for SDXL
export const SDXL_STYLE_MAP = {
  'photorealistic': 'photorealistic style, detailed, high quality',
  'cinematic': 'cinematic style, movie-like, dramatic',
  'artistic': 'artistic style, creative, expressive',
  'commercial': 'commercial photography style, professional',
  'portrait': 'portrait style, focused on subject'
};

// Lighting mapping for SDXL
export const SDXL_LIGHTING_MAP = {
  'natural': 'natural lighting',
  'dramatic': 'dramatic lighting',
  'soft': 'soft lighting',
  'studio': 'studio lighting'
};
